export const DEV_MODE = !!process.env.REACT_APP_DEV_MODE;
